import { RecommendedGrid } from './recommended-grid';

export { RecommendedGrid };
